import type { SessionService } from '@efdigital/ll-addon-auth';
import LtiPlatformList from '@efdigital/ll-admin-v2/components/lti/platform-list.gts';
import { buildListConsumingPlatforms } from '@efdigital/ll-admin-v2/data/builders/lti/lti-consuming-platforms';
import type { LtiConsumingPlatform } from '@efdigital/ll-admin-v2/data/types/lti';
import type { LibraryClientsEditModel } from '@efdigital/ll-admin-v2/routes/library/clients/client';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { Request } from '@warp-drive/ember';

interface Signature {
  Args: {
    model: LibraryClientsEditModel;
  };
}

export default class LtiIntegrationsIndexTemplate extends Component<Signature> {
  @service declare router: RouterService;
  @service declare session: SessionService;

  refreshRoute = (platform: LtiConsumingPlatform) => {
    void this.router.transitionTo(
      'library.clients.client.edit.lti-integrations.platform',
      platform.id
    );
  };

  get query() {
    return buildListConsumingPlatforms(this.args.model.client.id!);
  }

  <template>
    <h3 class="gud-eyebrow">LTI Integration</h3>
    <p class="lead mb-3">
      Learning Tools Interoperability (LTI) is a standard that lets users in a
      client's learning platform (such as Moodle, Canvas, or Blackboard) launch
      Xceed without setting up a separate login or SSO.
    </p>
    <div class="alert alert-info hstack align-items-start gap-2">
      <iconify-icon inline icon="ph:info" class="mt-1" />
      <div>
        <p>Most clients will use SSO to sign in to Xceed.</p>
        <p>LTI is worth considering when the customer needs learners to enter
          Xceed from their LMS and enrolment should happen at launch
          (just-in-time) rather than by us adding participants to each cohort
          manually.</p>
        <p class="mb-0">Use this page to register the client's LMS instance,
          exchange setup details with the customer's platform administrator, and
          then connect Xceed to the LMS.</p>
      </div>
    </div>

    {{#if @model.client.id}}
      <Request @query={{this.query}}>
        <:content as |content|>
          <LtiPlatformList
            @clientId={{@model.client.id}}
            @platforms={{content.data}}
            @onPlatformCreated={{this.refreshRoute}}
          />
        </:content>
      </Request>
    {{/if}}
  </template>
}
